import { FarmContacts as FarmContact } from 'types/FarmData';

interface FarmContactsProps {
  contacts: FarmContact[];
}

const telHref = (phone: string) => `tel:${phone.replace(/[\s()-]/g, '')}`;

const FarmContacts = ({ contacts }: FarmContactsProps) => (
  <div className={'farm-contact-cards'}>
    {contacts.map((contact) => (
      <article key={contact.id} className={'farm-contact-card'}>
        <div className={'farm-contact-card-head'}>
          {!!contact.full_name && (
            <p className={'farm-contact-card-title'}>{contact.full_name}</p>
          )}
          {!!contact.role && (
            <p className={'farm-contact-card-subtitle'}>{contact.role}</p>
          )}
        </div>
        {(!!contact.contact_phone || !!contact.contact_email) && (
          <div className={'farm-contact-card-body'}>
            {!!contact.contact_phone && (
              <a href={telHref(contact.contact_phone)}>
                {contact.contact_phone}
              </a>
            )}
            {!!contact.contact_email && (
              <a href={`mailto:${contact.contact_email}`}>
                {contact.contact_email}
              </a>
            )}
          </div>
        )}
      </article>
    ))}
  </div>
);

export default FarmContacts;
